import { publicRuntimeConfig } from '@/app/util/env'
import { appendParams } from '@/util/url'
import { GifResult, GifsResult } from '@giphy/js-fetch-api'
import { timeoutFetch } from 'utils/src/api/fetch'

export const getUserFavorites = async (params: object, accessToken: string) => {
    const url = appendParams(new URL(`${publicRuntimeConfig.apiUrl}user/favorites`), params)
    const res = await timeoutFetch({
        url,
        options: {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                authorization: `Token ${accessToken}`,
                'Content-Type': 'application/json',
            },
        },
    })
    return (await res.json()) as GifsResult
}

export const addFavorite = async (gif_id: string, accessToken: string, cookie: string, apiKey: string) => {
    return toggleFavorite(gif_id, accessToken, cookie, 'POST', apiKey)
}

export const removeFavorite = async (gif_id: string, accessToken: string, cookie: string, apiKey: string) => {
    return toggleFavorite(gif_id, accessToken, cookie, 'DELETE', apiKey)
}

const toggleFavorite = async (
    gif_id: string,
    accessToken: string,
    cookie: string,
    method: 'POST' | 'DELETE',
    apiKey: string
) => {
    const f = await timeoutFetch({
        url: getUrl(`user/favorites`, accessToken, apiKey),
        options: {
            method,
            body: `gif_id=${gif_id}`,
            headers: {
                cookie,
                Accept: 'application/json',
                Authorization: `Token ${accessToken}`,
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
            },
        },
    })
    return (await f.json()) as GifResult
}

export const checkIsFavorite = async (gifId: string, accessToken: string, apiKey: string) => {
    const result = await timeoutFetch({
        url: getUrl(`user/favorites/statuses`, accessToken, apiKey),
        options: {
            method: 'POST',
            headers: {
                Authorization: `Token ${accessToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ gif_ids: [gifId] }),
        },
    })
    const r = await result.json()
    return r.data.length > 0
}

function getUrl(path: string, accessToken: string, apiKey: string) {
    const p = `${publicRuntimeConfig.apiUrl}${path}`
    let url
    try {
        url = new URL(p)
    } catch (error) {
        console.error('Invalid URL:', p)
        throw error
    }
    return appendParams(url, {
        api_key: apiKey,
        access_token: accessToken,
    })
}
